import { ComponentStyleConfig } from "@chakra-ui/react";

import { textStyles } from "../foundations";
import { getHoverActiveFocusStyles } from "../utils";
import { ButtonVariants } from "../variants";

const { solid, outline, ghost } = ButtonVariants;

export const Button: ComponentStyleConfig = {
  baseStyle: {
    borderRadius: "full",
    boxShadow: "button",
    ".chakra-button__icon": {
      color: "currentColor",
      m: 0,
      mr: 2,
      h: "100%",
      alignItems: "center",
      svg: {
        maxH: "50%",
        w: "auto",
      },
    },
    svg: {
      h: "60%",
      minW: "60%",
    },
  },
  sizes: {
    xs: {
      h: 8,
      minW: 8,
      px: 4,
      ...textStyles.buttonXs,
    },
    sm: {
      h: 10,
      minW: 10,
      px: 4,
      ...textStyles.buttonSm,
    },
    md: {
      h: 12,
      minW: 12,
      px: 6,
      ...textStyles.buttonMd,
    },
    lg: {
      h: 14,
      minW: 14,
      px: 6,
      ...textStyles.buttonLg,
    },
    xl: {
      h: 16,
      minW: 16,
      px: 8,
      ...textStyles.buttonXl,
    },
    "2xl": {
      h: 18,
      minW: 18,
      px: 12,
      ...textStyles.button2Xl,
    },
  },
  variants: {
    [solid]: {
      ":disabled, :hover[disabled]": {
        bg: "blueGray.50",
        color: "blueGray",
        opacity: 1,
      },
    },
    [outline]: {
      ":disabled, :hover[disabled]": {
        color: "blueGray",
        borderColor: "blue.50",
        opacity: 1,
      },
    },
    [ghost]: {
      ...getHoverActiveFocusStyles({ bg: "transparent" }),
      ":disabled, :hover[disabled]": {
        color: "blueGray",
        opacity: 1,
      },
    },
  },
  defaultProps: {
    variant: solid,
    size: "md",
  },
};
